import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditEmpresaService } from '../../../empresa/services/edit-empresa.service';
import { EmpresaHelperService } from '../../../empresa/services/editar-empresa-helper.service';
import { Empresa } from '../../../empresa/interfaces/empresa.interface';

interface EmpresaParaVerDireccion {
    id: number;
    nit: string;
    razonSocial: string;
    direccion?: any;
}

@Component({
    selector: 'app-view-direccion-modal',
    templateUrl: './view-direccion-modal.component.html',
})
export class ViewDireccionModalComponent implements OnInit {
    @Input() empresaId: number;

    empresa: any;
    direccionFormateada = 'N/A';
    isLoading = true;
    errorMessage: string | null = null;

    constructor(
        public activeModal: NgbActiveModal, // Para controlar el modal (cerrarlo, etc.)
        private editEmpresaService: EditEmpresaService, // Tu servicio para obtener datos de la empresa
        private empresaHelperService: EmpresaHelperService // Tu helper para formatear la dirección
    ) {}

    ngOnInit(): void {
        if (this.empresaId) {
            this.loadEmpresaData();
        } else {
            this.errorMessage = 'No se proporcionó un ID de empresa.';
            this.isLoading = false;
        }
    }

    async loadEmpresaData(): Promise<void> {
        this.isLoading = true;
        this.errorMessage = null;
        try {
            const empresaData =
                await this.editEmpresaService.getEmpresaActualAdministrador(
                    `agente-vigilado/${this.empresaId}`
                );

            if (empresaData && empresaData.direccion) {
                this.empresa = {
                    id: empresaData.id,
                    nit: empresaData.nit,
                    razonSocial: empresaData.razonSocial,
                    direccion: empresaData.direccion,
                };
                // Formateamos la dirección para mostrarla
                this.direccionFormateada = this.formatDireccion(
                    this.empresa.direccion
                );
            } else {
                this.empresa = empresaData;
                this.errorMessage =
                    'No se encontró información de dirección para esta empresa.';
                this.direccionFormateada = 'No especificada';
            }
        } catch (error) {
            console.error('Error al cargar los datos de la empresa:', error);
            this.errorMessage = 'Ocurrió un error al cargar la información.';
        } finally {
            this.isLoading = false;
        }
    }

    private formatDireccion(direccion: any): string {
        if (!direccion) {
            return 'No especificada';
        }
        let dirString = '';
        if (direccion.viaPrincipalTipo)
            dirString += `${direccion.viaPrincipalTipo} `;
        if (direccion.viaPrincipalNumero)
            dirString += `${direccion.viaPrincipalNumero} `;
        if (direccion.viaPrincipalLetra)
            dirString += `${direccion.viaPrincipalLetra} `;

        const esBis =
            String(direccion.prefijoBis).toLowerCase() === 'true' ||
            direccion.prefijoBis === true;
        if (esBis) {
            dirString += `BIS `;
            if (direccion.letraPrefijo)
                dirString += `${direccion.letraPrefijo} `;
        }

        if (direccion.viaPrincipalCuadrante)
            dirString += `${direccion.viaPrincipalCuadrante} `;
        if (direccion.viaGeneradoraNumero)
            dirString += `# ${direccion.viaGeneradoraNumero} `;
        if (direccion.viaGeneradoraLetra)
            dirString += `${direccion.viaGeneradoraLetra} `;
        if (direccion.numeroPlaca) dirString += `- ${direccion.numeroPlaca} `;
        if (direccion.viaGeneradoraCuadrante)
            dirString += `${direccion.viaGeneradoraCuadrante} `;
        if (direccion.complemento) dirString += ` ${direccion.complemento}`;

        dirString = dirString.trim();

        const municipioNombre = direccion.municipio?.nombre || 'N/A';
        const departamentoNombre =
            direccion.municipio?.departamento?.nombre || 'N/A';

        if (dirString) {
            return `${dirString}, ${municipioNombre}, ${departamentoNombre}`;
        }
        return ` ${municipioNombre}, ${departamentoNombre} (Detalles de vía no especificados)`;
    }
}
